import {
  api,
  apiActionDispatcher,
  apiCall,
  chunkedMultiIdApiCall,
  multiIdApiActionDispatcher,
  multiIdRequestCacheCheck,
  signalRWrappedApiCall
} from './api';
import * as types from './types';
import {
  subscriptionTypes,
  signalRHubManager
} from './signalRHub/signalRHubManager';
import { keys, mapValues, pickBy } from 'lodash';
import { paramsReducer } from '../reducers';
import { getDefinedParamStringConstants, httpRequestHeader } from '../helpers';
import { paramsMetricsPayloadsHandler } from './signalRHub/hubPayloadsHandler';

const fetchParamsDispatcher = multiIdApiActionDispatcher({
  actionTypes: types.paramsActionTypes,
  emptyResult: () => { return {}; },
  responseHandler: (paramsById) => {
    const result = mapValues(paramsById, (paramsObj) => {
      const pickedParams = pickBy(
        paramsObj,
        (_value, key) => getDefinedParamStringConstants[key]
      );
      return pickedParams;
    });
    return result;
  }
});

export const fetchParamsByJobIds =
  (jobIds, requestHeader = httpRequestHeader.REQUEST_HEADER) =>
    signalRWrappedApiCall(
      chunkedMultiIdApiCall(
        jobIds,
        4000,
        fetchParamsDispatcher,
        api.params.fetchParamsByJobIds,
        (state, ids) => multiIdRequestCacheCheck(state.params.request, ids),
        requestHeader
      ),
      fetchParamsDispatcher([]),
      signalRHubManager,
      subscriptionTypes.params,
      state => keys(paramsReducer.paramsByJobIds(state)),
      (args, payloads) => paramsMetricsPayloadsHandler(args, payloads, 'job_id')
    );


const fetchMetricTestNodesDispatcher = apiActionDispatcher({
  actionTypes: types.metricTestNodesActionTypes,
  responseHandler: response => response
});

export const fetchMetricTestNodes = (jobName, afterTime) => apiCall(
  fetchMetricTestNodesDispatcher,
  api.params.fetchParamsByNames,
  (state) => state.metricsByDateInfo.lowerLatestFetch <= afterTime,
  null,
  null,
  ['Node', jobName, afterTime]
);


// WEBPACK FOOTER //
// src/actions/params.js